<div class="aca-sidenav-header" data-automation-id="app-sidenav-header">
  <div class="aca-sidenav-header-title" data-automation-id="app-sidenav-header-title">
    <button
      class="aca-sidenav-header-title-logo"
      data-automation-id="app-sidenav-header-title-logo"
      (click)="toggleNavBar.emit()"
      [attr.aria-label]="'APP.TOOLTIPS.COLLAPSE_NAVIGATION' | translate"
      #toggleNavbarButton>
      <img
        src="{{ logoUrl }}"
        title="{{ 'APP.TOOLTIPS.COLLAPSE_NAVIGATION' | translate }}"
        alt="{{ 'APP.TOOLTIPS.COLLAPSE_NAVIGATION_ALT' | translate }}"
        aria-hidden="true"
      />
    </button>

    <div
      class="aca-sidenav-header-title-text"
      data-automation-id="app-sidenav-header-title-text"
      [routerLink]="landingPage">
      {{ appName | translate }}
    </div>

    <aca-toolbar [items]="actions" />
  </div>
</div>
